// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:36.630Z
// Property: Windsail Apartments (ID: 6767906449165645)
// Collections: 26 amenities, 8 floorplans (live), 49 photos, 67 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165645",
  "property_external_id": "cmef2rf",
  "property_zillow_url": "https://www.zillow.com/b/windsail-tulsa-ok-63hJcY/",
  "property_apartments_url": "https://www.apartments.com/windsail-apts-tulsa-ok/cmef2rf/",
  "property_google_business_url": "https://www.google.com/maps/place/Windsail+Apartments/data=!4m2!3m1!1s0x0:0x1b56f8f4314578b0?sa=X&ved=2ahUKEwi_7Ki6g72SAxW4C0QIHareHUsQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "windsail-apartments",
  "property_name": "Windsail Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/windsail/",
  "property_domain": null,
  "property_address": "9808 East 73rd Street South",
  "property_full_address": "9808 East 73rd Street South, Tulsa, OK, 74133",
  "property_address_1": "9808 East 73rd Street South",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": null,
  "property_address_county": null,
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0581",
  "property_address_longitude": "-95.8669",
  "property_email": "windsail@caseusa.com",
  "property_phone": "(539) 233-0803",
  "property_call_tracking_phone": "844-825-9060",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Windsail Apts. in Tulsa, your ideal living space awaits. Choose from stylish one and two-bedroom floor plans, all boasting amenities like a refreshing pool, a state-of-the-art fitness center, and spacious walk-in closets. Enjoy outdoor gatherings at our picnic area or relax in the cozy clubhouse. Your new home is calling! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Windsail Apartments, your serene oasis nestled in the heart of Tulsa, Oklahoma. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs, offering comfortable and stylish living spaces you’ll be proud to call home. With a range of elegant amenities, you’ll find everything you desire right at your fingertips.\n\nDive into relaxation at our sparkling pool or challenge your friends to a match on our tennis court. Stay fit and active in our state-of-the-art fitness center, or unwind in our inviting clubhouse, perfect for social gatherings. Enjoy the convenience of on-site laundry facilities and package service, ensuring your everyday needs are met without hassle. With dedicated maintenance and a property manager on site, peace of mind is guaranteed.\n\nStep outside to enjoy our beautifully landscaped courtyard, equipped with grilling stations and picnic areas for those sunny afternoons. Inside your apartment, you’ll find modern amenities including air conditioning, a dishwasher, and high-speed internet access. Choose from features like vaulted ceilings, walk-in closets, and private balconies or patios—perfect for enjoying Tulsa’s pleasant evenings.\n\nAt Windsail Apartments, we prioritize a smoke-free environment for your comfort and well-being, with additional perks like cable readiness and built-in bookshelves to enhance your living experience.\n\nFind your new home today! Browse our availability or schedule a tour to explore our vibrant community. Discover the perfect blend of convenience, comfort, and style at Windsail Apartments—where your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-69ef-7259-ad46-f818ac7ec9bb.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas next to apartment buildings.",
    "public_id": "019fb44c-69ef-7259-ad46-f818ac7ec9bb",
    "storage_key": "property/6767906449165645/019fb44c-69ef-7259-ad46-f818ac7ec9bb.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "273",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.97069597069597",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "We allow up to two pets per unit (cats and dogs allowed). One-time non-refundable pet fee: $500 per pet. Monthly pet rent: $25 per pet.",
  "property_petpolicy_info": "*Service animals are exempt from pet fees and pet rent. Further documentation may be necessary.\nIf you have any inquiries regarding our pet policy, feel free to contact us. Schedule a tour of Windsail to determine if our Tulsa apartments align with your needs and those of your pet.\n",
  "property_online_leasing_url": "https://windsailapartmentstulsa.securecafe.com/onlineleasing/windsail-apts/floorplans.aspx",
  "property_resident_portal_url": "https://windsailapartmentstulsa.securecafe.com/residentservices/windsail-apts/userlogin.aspx",
  "property_apply_now_url": "https://windsailapartmentstulsa.securecafe.com/onlineleasing/windsail-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-658f-72d9-b0c3-f68080938959.webp",
  "property_primary_logo_media": {
    "alt_text": "Windsail Apartment Homes logo",
    "public_id": "019cfb4d-658f-72d9-b0c3-f68080938959",
    "storage_key": "property/6767906449165645/019cfb4d-658f-72d9-b0c3-f68080938959.webp",
    "width": 360,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4e-86b1-7221-860c-d282ccd0f504.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb4e-86b1-7221-860c-d282ccd0f504",
    "storage_key": "property/6767906449165645/019cfb4e-86b1-7221-860c-d282ccd0f504.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4e-975c-732e-babc-0864d2354bb8.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Windsail Apartment Homes logo",
    "public_id": "019cfb4e-975c-732e-babc-0864d2354bb8",
    "storage_key": "property/6767906449165645/019cfb4e-975c-732e-babc-0864d2354bb8.webp",
    "width": 360,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4e-a027-71ff-8859-02953a24dee6.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Windsail Apartment Homes logo",
    "public_id": "019cfb4e-a027-71ff-8859-02953a24dee6",
    "storage_key": "property/6767906449165645/019cfb4e-a027-71ff-8859-02953a24dee6.webp",
    "width": 360,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#556771",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "600 - 1000",
  "property_sqft_min": "600",
  "property_sqft_max": "1000",
  "property_price_range": "539 - 1354",
  "property_price_min": "539",
  "property_price_max": "1354",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/WindsailTulsa/photos/",
  "property_instagram_url": "https://www.instagram.com/windsailapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJE_zo1rmNtocRsHhFMfT4Vhs",
  "property_youtube_url": "https://www.youtube.com/watch?v=425gMP1yD48",
  "property_yelp_url": "https://www.yelp.com/biz/windsail-tulsa-2",
  "property_tiktok_url": "https://www.tiktok.com/@windsailapartmentstulsa",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Windsail Apts.",
  "property_home_romance_title": "Embrace a New Beginning in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Windsail Apts. in Tulsa, where comfort meets convenience. Choose from spacious one and two-bedroom floor plans equipped with modern amenities like Wi-Fi, air conditioning, and walk-in closets. Enjoy relaxing by the pool, playing tennis, or unwinding on your private balcony. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Windsail Apts. in vibrant Tulsa, Oklahoma, your ideal living space awaits. Choose from thoughtfully designed one or two-bedroom floor plans that perfectly balance comfort and style. Dive into our selection and find an apartment that reflects your lifestyle. Your new home is just a click away—start browsing today!",
  "property_home_gallery_blurb": "At Windsail Apts. in Tulsa, Oklahoma, your ideal lifestyle awaits! Choose from spacious one and two-bedroom floor plans featuring high ceilings, walk-in closets, and modern kitchens. Enjoy sunny days by the pool, get active in the fitness center, or unwind in the inviting clubhouse. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Windsail Apts. in vibrant Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans invite you to experience comfort and convenience. Dive into the charming neighborhood, where local favorites and hidden gems await. Uncover what makes our community truly special and enrich your lifestyle today!",
  "property_home_reviews_blurb": "At Windsail Apartments in Tulsa, our residents rave about the top-notch service and vibrant community. One happy tenant praised our maintenance team as \"excellent and speedy,\" highlighting our commitment to quality care. Enjoy easy access to shopping, dining, and a welcoming atmosphere that makes you feel right at home!",
  "property_neighborhood_blurb": "At Windsail Apts. in Tulsa, Oklahoma, you'll find modern one and two-bedroom floor plans surrounded by vibrant educational opportunities. Nestled near Tulsa Community College, Oral Roberts University, and top Union schools, your new home offers a lifestyle rich in resources. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Windsail Apts. in Tulsa, enjoy the perfect blend of comfort and convenience. Dive into our sparkling pool, energize in the fitness center, or unwind in our serene picnic area. With spacious one and two-bedroom floor plans and a host of modern amenities, your ideal home awaits!",
  "property_applynow_blurb": "At Windsail Apts. in Tulsa, come home to thoughtfully designed one and two-bedroom layouts that blend comfort with style. Enjoy top-notch amenities, from a refreshing pool and fitness center to a serene picnic area. Elevate your living experience—lease your dream apartment today and start your next adventure!",
  "property_contactus_blurb": "At Windsail Apts. in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Whether you’re starting a new chapter or seeking a cozy home, we’re here to help you find your ideal space. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Windsail Apts. in Tulsa, Oklahoma, you’ll find thoughtfully designed one and two-bedroom floor plans that feel like home. Dive into our FAQs page for insights and answers about our vibrant community, ensuring you have all the information you need to make your move seamless and enjoyable.",
  "property_floorplans_blurb": "At Windsail Apts. in Tulsa, Oklahoma, your ideal living space awaits. Choose from our thoughtfully designed one and two bedroom floor plans, tailored for comfort and convenience. Browse our available options today and embark on a journey to find your perfect home in our vibrant community.",
  "property_gallery_blurb": "At Windsail Apts. in Tulsa, you’ll find inviting one- and two-bedroom floor plans enriched with modern comforts. Imagine sunny days by the pool, vibrant community events in the clubhouse, and relaxing evenings on your private balcony. Picture yourself living here and embracing a lifestyle tailored just for you!",
  "property_interactivemap_blurb": "Elevate your lifestyle at Windsail Apts. in Tulsa, where spacious one and two-bedroom layouts await. Enjoy amenities like a refreshing pool, modern fitness center, and inviting courtyard. With our interactive community map, easily find your perfect home and embrace the vibrant community you deserve. Your next adventure starts here!",
  "property_pets_blurb": "At Windsail Apts. in Tulsa, your furry friends are part of the family! With space for up to two pets, our community embraces the joy they bring. Enjoy spacious living with trails nearby, ensuring both you and your pets enjoy a vibrant lifestyle. Live where comfort meets companionship!",
  "property_referafriend_blurb": "At Windsail Apts. in Tulsa, Oklahoma, cozy living awaits with inviting one and two-bedroom floor plans. Share the charm of our community with friends—after all, great friends make great neighbors! Refer a friend today and enjoy the perks of vibrant living together. Your ideal apartment life starts here!",
  "property_residentaccess_blurb": "At Windsail Apts. in Tulsa, Oklahoma, our diverse floor plans, from cozy one-bedroom retreats to spacious two-bedroom havens, cater to your lifestyle needs. Log in to the resident portal for seamless rent payments, easy maintenance requests, and much more. Experience hassle-free living today!",
  "property_reviews_blurb": "At Windsail Apts. in Tulsa, residents thrive in a vibrant community where comfort meets convenience. With a dedicated maintenance team praised for their “excellent and speedy response,” and friendly staff who know you by name, it’s no wonder our residents feel truly at home. See what our residents have to say about living at our community!",
  "property_created_at": "1753982398129",
  "property_scheduletour_blurb": "At Windsail Apts. in Tulsa, Oklahoma, your ideal home awaits! Choose from our stylish one and two-bedroom floor plans designed for comfort and convenience. Ready to experience the community vibe? Schedule a tour today and hear firsthand from our residents why they love calling Windsail Apts. home!",
  "property_thankyou_blurb": "Thank you for reaching out to Windsail Apts. in Tulsa, Oklahoma! Our inviting one and two-bedroom floor plans are designed to suit your lifestyle. Stay tuned as our dedicated team connects with you soon—exciting possibilities for your new home await just around the corner!",
  "property_virtualtours_blurb": "At Windsail Apts. in vibrant Tulsa, OK, each thoughtfully designed floor plan, from cozy one-bedrooms to spacious two-bedrooms, offers an inviting sanctuary. Experience the charm and elegance through our virtual tour, and visualize your new home today. Your dream apartment awaits—let's make it a reality!",
  "property_copyright": "2025 All Rights Reserved. Windsail Apts.",
  "property_seo_title_home": "Windsail Apts. | Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Welcome to Windsail Apts. in Tulsa! Enjoy spacious one- and two-bedroom layouts with premium amenities like a pool, fitness center, and clubhouse. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Tulsa, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal space at Windsail Apts. in Tulsa! Choose from stylish one or two-bedroom floor plans designed for comfort and modern living. Browse now!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Windsail Apts. in Tulsa, OK! Dive into luxury with top-notch amenities like a pool, fitness center, and inviting clubhouse. Your oasis awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "\"Imagine life at Windsail Apts. in Tulsa—luxury amenities, stunning floor plans, and a welcoming community. Check out our photo gallery and see your new home!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Windsail Apts. Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Windsail Apts. in Tulsa, OK! Take a virtual tour to uncover our spacious one and two-bedroom floor plans today! ",
  "property_seo_title_interactivemap": "Interactive Map | Windsail Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect fit at Windsail Apts. in Tulsa, OK! Use our interactive map to browse floor plans, explore amenities, and unlock your dream home today.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Dive into the vibrant Tulsa scene surrounding Windsail Apts. Uncover local favorites, parks, and dining hotspots just steps from your door.",
  "property_seo_title_contact": "Contact Us | Windsail Apts.",
  "property_seo_description_contact": "Connect with the Windsail Apts. team in Tulsa! Inquire about our one and two-bedroom floor plans that fit your lifestyle. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Get the answers you need about Windsail Apts. in Tulsa. From amenities to floor plans, find out why your next home awaits. Check out our FAQs today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Live the good life at Windsail Apts. in Tulsa! Check out our residents' reviews and discover unmatched amenities, from a sparkling pool to cozy balconies.",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Find your perfect home at Windsail Apts. in Tulsa! Enjoy chic one- and two-bedroom layouts, stunning amenities, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Windsail Apts.",
  "property_seo_description_residentaccess": "Login to your Windsail Apts. resident portal for seamless rent payments, maintenance requests, and community updates—all from the comfort of your home in Tulsa!",
  "property_seo_title_referafriend": "Refer A Friend | Windsail Apts.",
  "property_seo_description_referafriend": "\"Refer a friend to Windsail Apts. in Tulsa! Enjoy a community where great friends become great neighbors. Share the love and elevate your living experience!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Windsail Apts.",
  "property_seo_description_scheduletour": "\"Experience vibrant living at Windsail Apts. in Tulsa! Schedule a tour today and envision your new home filled with comfort and modern amenities.\"",
  "property_seo_title_privacy": "Privacy Policy | Windsail Apts.",
  "property_seo_description_privacy": "At Windsail Apts. in Tulsa, your privacy matters. Learn how we protect your information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Windsail Apts.",
  "property_seo_description_accessibility": "Experience seamless living at Windsail Apts. in Tulsa. Our commitment to digital inclusion ensures everyone feels at home. Join us in fostering accessibility for all!",
  "property_seo_title_sitemap": "Sitemap | Windsail Apts.",
  "property_seo_description_sitemap": "Navigate your way to comfort and style at Windsail Apts. in Tulsa, OK. Uncover each feature and amenity on our comprehensive sitemap!",
  "property_seo_title_thankyou": "Thank You | Windsail Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Windsail Apts. in Tulsa! Our team will connect with you soon to help you find your ideal home by the serene waters.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866204785",
  "amenities": [
    {
      "id": "ec_989d94d3f6cf1f61abc32d94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397536",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ddab4571cff08b12afd4c70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397537",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bba632022ca51f3a23775db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397538",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc29173c89a14069ddef7364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397539",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27cd856c596aa921d1155c47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397540",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffe11b15fcad97f0fda6b9d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397542",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53b1b6975efdde6e7c8ac742",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397543",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e35406fe2be0bb7a049365e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397544",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffe0982a756832dff17367c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397545",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5db5f914cb518ed26482e04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127397547",
      "title": "Dog Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cc0128cec322b7a86a3ffab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "128017296",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51c8d891fade7d000c348dfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "128042568",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb2e1decaec65c9b384604b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127398993",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29b27b46d33ee541cbac63bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127398994",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6433cd6c7fbd63b07401d3c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127398995",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db22a24c5468c68bb1d21317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127398996",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee5a0f57dfd897dedc26f354",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127398997",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a390d9d7f2d5affd41e3285",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127398998",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3066c322ca064f4cd3d26f58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127398999",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fde9064281a054d6d9cac1b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127399000",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9683d1f2c2383a90b3d34fdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127399001",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2b71a1681800ce1717cad9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127399002",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e779512b37ddfa758b1ec25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127399003",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a59e3f9dd257c84a19e2e6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127399004",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ffb9d08b8e65a24da862dd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127399006",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ee55bf8d59ffef0b06a241d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "yardi",
      "external_id": "127399009",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_84f83be8-68bf-44f5-8193-1c10582082a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-cd78-718d-b096-852684c335a3.webp",
      "image_media": {
        "alt_text": "Entrance sign for Windsail Apartment Homes with shrubs and a blue building behind.",
        "public_id": "019fb44b-cd78-718d-b096-852684c335a3",
        "storage_key": "property/6767906449165645/019fb44b-cd78-718d-b096-852684c335a3.webp",
        "width": 1111,
        "height": 740
      },
      "title": "Community",
      "description": "Exterior view of Windsail Apartment Homes' entrance sign with manicured shrubs and a blue-toned building in the background.",
      "link": "",
      "alt_text": "Entrance sign for Windsail Apartment Homes with shrubs and a blue building behind.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/48324/Windsail%20Entrance%20Signage.jpg"
    },
    {
      "id": "custom_fcf37618-6d0a-4880-9ebe-43ea9e58dda3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-ccbd-7618-b994-1d19f6d4c530.webp",
      "image_media": {
        "alt_text": "Living room with a grey sofa, armchair, TV on a console, coffee table, and vertical blinds.",
        "public_id": "019fb44b-ccbd-7618-b994-1d19f6d4c530",
        "storage_key": "property/6767906449165645/019fb44b-ccbd-7618-b994-1d19f6d4c530.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with neutral tones and contemporary furnishings.",
      "link": "",
      "alt_text": "Living room with a grey sofa, armchair, TV on a console, coffee table, and vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304817%20(1).JPG"
    },
    {
      "id": "custom_340955f8-ef1f-4f66-a88a-092ab483f63f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-ccb2-74bd-81c5-bdf107aaef3c.webp",
      "image_media": {
        "alt_text": "Bright living room in an apartment with a tan sofa, coffee table, art, and large window with vertical blinds.",
        "public_id": "019fb44b-ccb2-74bd-81c5-bdf107aaef3c",
        "storage_key": "property/6767906449165645/019fb44b-ccb2-74bd-81c5-bdf107aaef3c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living room with modern furnishings, artwork, and abundant natural light.",
      "link": "",
      "alt_text": "Bright living room in an apartment with a tan sofa, coffee table, art, and large window with vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304977%20(1).JPG"
    },
    {
      "id": "custom_1acd6dfa-c8dd-4366-88d7-97c1d255a4a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-d9c9-74e1-8027-72656142195d.webp",
      "image_media": {
        "alt_text": "Bedroom with dark wooden bed frame, nightstand, and window with blinds.",
        "public_id": "019fb44b-d9c9-74e1-8027-72656142195d",
        "storage_key": "property/6767906449165645/019fb44b-d9c9-74e1-8027-72656142195d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom in neutral tones with a large bed, nightstand, and natural light from a window.",
      "link": "",
      "alt_text": "Bedroom with dark wooden bed frame, nightstand, and window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305017%20(1).JPG"
    },
    {
      "id": "custom_f139ba42-e8e8-4225-92bb-59f56fbc8f12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-d9ca-7632-8be4-914341466bf0.webp",
      "image_media": {
        "alt_text": "Apartment living room with TV on a wooden stand, seating, plant, and sliding door to balcony.",
        "public_id": "019fb44b-d9ca-7632-8be4-914341466bf0",
        "storage_key": "property/6767906449165645/019fb44b-d9ca-7632-8be4-914341466bf0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright living room in a stylish apartment featuring a TV on a wooden console, seating area, plants, and balcony access.",
      "link": "",
      "alt_text": "Apartment living room with TV on a wooden stand, seating, plant, and sliding door to balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304972%20(1).JPG"
    },
    {
      "id": "custom_a90d504b-e83f-4dfa-9237-5a14822928f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-dc2c-7672-84f5-55195c3f4266.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a wooden bed, striped bedding, and wall art.",
        "public_id": "019fb44b-dc2c-7672-84f5-55195c3f4266",
        "storage_key": "property/6767906449165645/019fb44b-dc2c-7672-84f5-55195c3f4266.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a rustic wood bed, soft gray stripes, and calming decor.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with a wooden bed, striped bedding, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304862%20(1).JPG"
    },
    {
      "id": "custom_f9f7179c-5c30-4a2b-9e31-7495fbd304bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-e4f7-75a3-8484-d7e0ebd0ec2e.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen with white appliances, wooden cabinets, and a double sink.",
        "public_id": "019fb44b-e4f7-75a3-8484-d7e0ebd0ec2e",
        "storage_key": "property/6767906449165645/019fb44b-e4f7-75a3-8484-d7e0ebd0ec2e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Compact kitchen in a multifamily unit with white appliances, laminate countertops, and wood cabinets.",
      "link": "",
      "alt_text": "Compact apartment kitchen with white appliances, wooden cabinets, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304932%20(1).JPG"
    },
    {
      "id": "custom_6f69e45e-72c1-4c46-addf-0f4fee6e51fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-e655-73e8-a660-d85adeb7126c.webp",
      "image_media": {
        "alt_text": "Narrow apartment storage nook with wood floor, abstract black-and-white wall art, and woven basket.",
        "public_id": "019fb44b-e655-73e8-a660-d85adeb7126c",
        "storage_key": "property/6767906449165645/019fb44b-e655-73e8-a660-d85adeb7126c.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Interior storage nook in a multifamily unit featuring abstract wall art, a wire basket, baskets on a shelf, and wood floors.",
      "link": "",
      "alt_text": "Narrow apartment storage nook with wood floor, abstract black-and-white wall art, and woven basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304887%20(1).JPG"
    },
    {
      "id": "custom_0bf7012a-efed-4968-bf86-0b8943673237",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-e6f7-7239-b622-ae622d343153.webp",
      "image_media": {
        "alt_text": "Laundry closet with washer on the left and dryer on the right, white textured walls, wood floor.",
        "public_id": "019fb44b-e6f7-7239-b622-ae622d343153",
        "storage_key": "property/6767906449165645/019fb44b-e6f7-7239-b622-ae622d343153.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Compact apartment laundry area with a washer and dryer and a small shelf on a warm wood floor.",
      "link": "",
      "alt_text": "Laundry closet with washer on the left and dryer on the right, white textured walls, wood floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305032%20(1).JPG"
    },
    {
      "id": "custom_2fca5a67-cd1d-462a-acbf-2f5babe493bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-e71b-75be-adcb-e3f4795da725.webp",
      "image_media": {
        "alt_text": "Open-concept living room and dining area in an apartment with a beige sofa and round coffee table.",
        "public_id": "019fb44b-e71b-75be-adcb-e3f4795da725",
        "storage_key": "property/6767906449165645/019fb44b-e71b-75be-adcb-e3f4795da725.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open living space in a modern apartment, featuring a beige sofa, textured pillows, and a dining table near the kitchen.",
      "link": "",
      "alt_text": "Open-concept living room and dining area in an apartment with a beige sofa and round coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304727%20(1).JPG"
    },
    {
      "id": "custom_3a517ff9-c145-4784-9560-5820ce11bd86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-f45f-73ac-b949-bad94aa19ed7.webp",
      "image_media": {
        "alt_text": "Bedroom in a rental with a queen bed, nightstand, lamp, art, and a large window with vertical blinds.",
        "public_id": "019fb44b-f45f-73ac-b949-bad94aa19ed7",
        "storage_key": "property/6767906449165645/019fb44b-f45f-73ac-b949-bad94aa19ed7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with neutral tones, contemporary decor, and a bright view through a large window.",
      "link": "",
      "alt_text": "Bedroom in a rental with a queen bed, nightstand, lamp, art, and a large window with vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304782%20(1).JPG"
    },
    {
      "id": "custom_45f30157-34c2-49ce-94d4-ee6e553ee8c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-f5bd-732f-82f2-021f3d94ffaf.webp",
      "image_media": {
        "alt_text": "White walk-in closet with wire shelves and three wicker baskets on beige carpet.",
        "public_id": "019fb44b-f5bd-732f-82f2-021f3d94ffaf",
        "storage_key": "property/6767906449165645/019fb44b-f5bd-732f-82f2-021f3d94ffaf.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Walk-in apartment closet with white walls, wire shelves on both sides, and three wicker baskets for storage.",
      "link": "",
      "alt_text": "White walk-in closet with wire shelves and three wicker baskets on beige carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304797%20(1).JPG"
    },
    {
      "id": "custom_d342d70d-e550-45e1-a022-ea161b534867",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-fb50-701b-8f39-7102411c6cfe.webp",
      "image_media": {
        "alt_text": "Playground on a grassy lawn with a colorful play structure inside a fenced area.",
        "public_id": "019fb44b-fb50-701b-8f39-7102411c6cfe",
        "storage_key": "property/6767906449165645/019fb44b-fb50-701b-8f39-7102411c6cfe.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Family-friendly community playground with a multi-structure playset on a grassy field.",
      "link": "",
      "alt_text": "Playground on a grassy lawn with a colorful play structure inside a fenced area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305206.JPG"
    },
    {
      "id": "custom_aa5bcbe1-dbbe-4e5d-a183-de91f5bf40da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-0036-7547-9d45-8b1419805943.webp",
      "image_media": {
        "alt_text": "Apartment bathroom with toilet, wood vanity, marble countertop, and two framed mirrors.",
        "public_id": "019fb44c-0036-7547-9d45-8b1419805943",
        "storage_key": "property/6767906449165645/019fb44c-0036-7547-9d45-8b1419805943.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a wood vanity, marble countertop, mirrors, and decorative artwork.",
      "link": "",
      "alt_text": "Apartment bathroom with toilet, wood vanity, marble countertop, and two framed mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305052%20(1).JPG"
    },
    {
      "id": "custom_d70692c4-0946-49b2-8e86-124a80c41b79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-022d-7458-a9b0-acb008d261a0.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment complex with balconies and a green lawn.",
        "public_id": "019fb44c-022d-7458-a9b0-acb008d261a0",
        "storage_key": "property/6767906449165645/019fb44c-022d-7458-a9b0-acb008d261a0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a blue-siding apartment community with balconies and well-kept lawns.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment complex with balconies and a green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304626%20(1).JPG"
    },
    {
      "id": "custom_502e8203-9a33-4281-a1fc-98f1ad10c1d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-0321-7476-8eb1-8b1ad77e5ca9.webp",
      "image_media": {
        "alt_text": "Outdoor community space with picnic tables, umbrellas, and a small playground in the background.",
        "public_id": "019fb44c-0321-7476-8eb1-8b1ad77e5ca9",
        "storage_key": "property/6767906449165645/019fb44c-0321-7476-8eb1-8b1ad77e5ca9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A well-kept outdoor community area with picnic tables, shade umbrellas, and a playground beside the apartment buildings.",
      "link": "",
      "alt_text": "Outdoor community space with picnic tables, umbrellas, and a small playground in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305191.JPG"
    },
    {
      "id": "custom_2db2f5b6-98ae-45be-86a5-b51edb1bee7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-0c16-7156-b429-a6ec4a75bf60.webp",
      "image_media": {
        "alt_text": "Blue exterior balcony with metal chairs and a round table overlooking a street.",
        "public_id": "019fb44c-0c16-7156-b429-a6ec4a75bf60",
        "storage_key": "property/6767906449165645/019fb44c-0c16-7156-b429-a6ec4a75bf60.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor balcony on a blue building with metal patio furniture and a view of a fence and road.",
      "link": "",
      "alt_text": "Blue exterior balcony with metal chairs and a round table overlooking a street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304927%20(2).JPG"
    },
    {
      "id": "custom_e483cc73-c6d8-45e5-94a9-c0ef5a61b818",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-1187-7518-8516-6c3344eb4687.webp",
      "image_media": {
        "alt_text": "Interior of a community gym with cardio machines and wall murals.",
        "public_id": "019fb44c-1187-7518-8516-6c3344eb4687",
        "storage_key": "property/6767906449165645/019fb44c-1187-7518-8516-6c3344eb4687.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Well-equipped apartment community gym with cardio and strength machines and vibrant mural walls.",
      "link": "",
      "alt_text": "Interior of a community gym with cardio machines and wall murals.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304707%20(1).JPG"
    },
    {
      "id": "custom_95532972-39e6-4ea5-96fa-fac5575e102a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-11db-74fd-877a-744affbc7829.webp",
      "image_media": {
        "alt_text": "Bedroom in apartment with a dark wood bed frame, two nightstands, lamps, and a large window with vertical blinds.",
        "public_id": "019fb44c-11db-74fd-877a-744affbc7829",
        "storage_key": "property/6767906449165645/019fb44c-11db-74fd-877a-744affbc7829.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, furnished bedroom in a stylish apartment featuring a king-size bed, two nightstands, and warm decor.",
      "link": "",
      "alt_text": "Bedroom in apartment with a dark wood bed frame, two nightstands, lamps, and a large window with vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305037%20(1).JPG"
    },
    {
      "id": "custom_808d44d5-fa76-434c-97a7-90c162a7586e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-16d5-7359-927f-6e30acd9b565.webp",
      "image_media": {
        "alt_text": "Bright living area with sofa, coffee table, dining table, and open kitchen in an apartment.",
        "public_id": "019fb44c-16d5-7359-927f-6e30acd9b565",
        "storage_key": "property/6767906449165645/019fb44c-16d5-7359-927f-6e30acd9b565.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright open-concept living space with seating, a dining area, and a visible kitchen—ideal for modern apartment living.",
      "link": "",
      "alt_text": "Bright living area with sofa, coffee table, dining table, and open kitchen in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304832%20(1).JPG"
    },
    {
      "id": "custom_c481e93a-399d-44f7-8e70-bb9430ac6414",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-184f-7102-9238-6fa385d260b1.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sofa, patterned chair, coffee table, wall art, and sliding door.",
        "public_id": "019fb44c-184f-7102-9238-6fa385d260b1",
        "storage_key": "property/6767906449165645/019fb44c-184f-7102-9238-6fa385d260b1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment living room with neutral tones, a gray sofa, patterned chair, coffee table, and wall art.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, patterned chair, coffee table, wall art, and sliding door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304822%20(1).JPG"
    },
    {
      "id": "custom_943b9ad5-8d59-4c89-afdb-6b91493622ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-1e12-7608-b4cc-0ae9b765bb5a.webp",
      "image_media": {
        "alt_text": "Bedroom with tufted headboard, two gold nightstands, and a large window with sheer blinds.",
        "public_id": "019fb44c-1e12-7608-b4cc-0ae9b765bb5a",
        "storage_key": "property/6767906449165645/019fb44c-1e12-7608-b4cc-0ae9b765bb5a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A stylish apartment bedroom with a tufted headboard, gold nightstands, warm lamps, and decorative wall accents.",
      "link": "",
      "alt_text": "Bedroom with tufted headboard, two gold nightstands, and a large window with sheer blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304952%20(1).JPG"
    },
    {
      "id": "custom_868fbcd9-6a34-4e9b-a3cf-985b685822b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-1ef6-710e-81f5-af65862d7379.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV on a wooden console, and sliding balcony door.",
        "public_id": "019fb44c-1ef6-710e-81f5-af65862d7379",
        "storage_key": "property/6767906449165645/019fb44c-1ef6-710e-81f5-af65862d7379.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living area with a gas fireplace, TV on a wood console, and a sliding balcony door.",
      "link": "",
      "alt_text": "Living room with fireplace, TV on a wooden console, and sliding balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304722%20(1).JPG"
    },
    {
      "id": "custom_2325b0f0-5cd7-45bb-9de8-063704bc6584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-2321-77cc-b76c-68316c019c32.webp",
      "image_media": {
        "alt_text": "Bathroom with wooden vanity, sink, mirror, toilet, and a patterned shower curtain.",
        "public_id": "019fb44c-2321-77cc-b76c-68316c019c32",
        "storage_key": "property/6767906449165645/019fb44c-2321-77cc-b76c-68316c019c32.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a granite countertop, wooden cabinets, and a patterned shower curtain.",
      "link": "",
      "alt_text": "Bathroom with wooden vanity, sink, mirror, toilet, and a patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304872%20(2).JPG"
    },
    {
      "id": "custom_fc5adf32-6d06-4531-9814-9991850fcd05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-248f-72ef-b6df-f24fa644c40d.webp",
      "image_media": {
        "alt_text": "Bright apartment living area with a dining table, chairs, built-in shelves, and a glass coffee table.",
        "public_id": "019fb44c-248f-72ef-b6df-f24fa644c40d",
        "storage_key": "property/6767906449165645/019fb44c-248f-72ef-b6df-f24fa644c40d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept living room in a garden-style apartment with a dining nook, shelving, and a glass coffee table.",
      "link": "",
      "alt_text": "Bright apartment living area with a dining table, chairs, built-in shelves, and a glass coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304917%20(1).JPG"
    },
    {
      "id": "custom_08cdc0d9-2c8b-4274-9409-5254b08d9a4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-29ee-7548-a965-82266dfc9dc6.webp",
      "image_media": {
        "alt_text": "Dining area in an apartment with a round table and four upholstered chairs near sliding glass doors.",
        "public_id": "019fb44c-29ee-7548-a965-82266dfc9dc6",
        "storage_key": "property/6767906449165645/019fb44c-29ee-7548-a965-82266dfc9dc6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright dining nook in a spacious apartment with a round table and four chairs, adjacent to the kitchen.",
      "link": "",
      "alt_text": "Dining area in an apartment with a round table and four upholstered chairs near sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304922%20(1).JPG"
    },
    {
      "id": "custom_3dc6d84e-28ce-4b79-ab21-0c657bc51955",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-29f6-7358-a8f3-b7a3e80121da.webp",
      "image_media": {
        "alt_text": "Small dining area with round wooden table and four brown chairs in an apartment unit.",
        "public_id": "019fb44c-29f6-7358-a8f3-b7a3e80121da",
        "storage_key": "property/6767906449165645/019fb44c-29f6-7358-a8f3-b7a3e80121da.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy dining nook in an apartment with abstract wall art and a partial kitchenette view.",
      "link": "",
      "alt_text": "Small dining area with round wooden table and four brown chairs in an apartment unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304987%20(1).JPG"
    },
    {
      "id": "custom_9f6c91a4-743b-464f-ae84-8c8333a17887",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-2fc6-718f-83b3-c3f3998cd800.webp",
      "image_media": {
        "alt_text": "Bathroom with granite countertop, wooden vanity, toilet, and a colorful floral shower curtain.",
        "public_id": "019fb44c-2fc6-718f-83b3-c3f3998cd800",
        "storage_key": "property/6767906449165645/019fb44c-2fc6-718f-83b3-c3f3998cd800.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Apartment bathroom featuring a granite vanity, cabinetry, toilet, and a bright floral shower curtain.",
      "link": "",
      "alt_text": "Bathroom with granite countertop, wooden vanity, toilet, and a colorful floral shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305027%20(1).JPG"
    },
    {
      "id": "custom_d7ce4b98-b912-4ff0-9964-93c8940bbc21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-3151-775d-b39d-cbd735db2078.webp",
      "image_media": {
        "alt_text": "Balcony railing view overlooking a street, green lawn, and trees at the apartment community.",
        "public_id": "019fb44c-3151-775d-b39d-cbd735db2078",
        "storage_key": "property/6767906449165645/019fb44c-3151-775d-b39d-cbd735db2078.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior balcony view at a multifamily community showing landscaping and surrounding street.",
      "link": "",
      "alt_text": "Balcony railing view overlooking a street, green lawn, and trees at the apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304801%20(1).JPG"
    },
    {
      "id": "custom_97b381e8-c154-49f7-897b-ff30fd8039e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-348b-7338-a008-7681fa527e81.webp",
      "image_media": {
        "alt_text": "Fenced tennis court in front of blue-and-brick apartment buildings.",
        "public_id": "019fb44c-348b-7338-a008-7681fa527e81",
        "storage_key": "property/6767906449165645/019fb44c-348b-7338-a008-7681fa527e81.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A modern apartment community with a shared tennis court and multi-story buildings in blue and brick.",
      "link": "",
      "alt_text": "Fenced tennis court in front of blue-and-brick apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305171.JPG"
    },
    {
      "id": "custom_e8e17a37-da97-4357-a1ca-d832bc54c8ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-3a7b-7097-9470-e4be17888b65.webp",
      "image_media": {
        "alt_text": "Galley-style apartment kitchen with wood cabinets, white appliances, and beige countertops.",
        "public_id": "019fb44c-3a7b-7097-9470-e4be17888b65",
        "storage_key": "property/6767906449165645/019fb44c-3a7b-7097-9470-e4be17888b65.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Galley-style apartment kitchen with wood cabinets, beige countertops, and white appliances (stove, microwave, fridge, dishwasher).",
      "link": "",
      "alt_text": "Galley-style apartment kitchen with wood cabinets, white appliances, and beige countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304992%20(1).JPG"
    },
    {
      "id": "custom_051c0ad6-b6fc-4f7d-b947-658a3a57426d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-3a7c-75e9-aaa3-1bee6908bfc5.webp",
      "image_media": {
        "alt_text": "Bedroom in apartment with a wooden bed, geometric bedding, a nightstand, lamp, and a window with blinds.",
        "public_id": "019fb44c-3a7c-75e9-aaa3-1bee6908bfc5",
        "storage_key": "property/6767906449165645/019fb44c-3a7c-75e9-aaa3-1bee6908bfc5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with wood bed, neutral geometric bedding, and natural light.",
      "link": "",
      "alt_text": "Bedroom in apartment with a wooden bed, geometric bedding, a nightstand, lamp, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304762%20(1).JPG"
    },
    {
      "id": "custom_10d50c40-1a17-4998-a015-c349a280120d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-3c64-7509-a366-2fb270d651ea.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, blue accent chair, glass coffee table, and colorful abstract wall art.",
        "public_id": "019fb44c-3c64-7509-a366-2fb270d651ea",
        "storage_key": "property/6767906449165645/019fb44c-3c64-7509-a366-2fb270d651ea.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment living area featuring modern furniture, vibrant art, and cozy textures.",
      "link": "",
      "alt_text": "Living room with white sofa, blue accent chair, glass coffee table, and colorful abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304912%20(1).JPG"
    },
    {
      "id": "custom_8460807b-cd10-4bbc-bd02-b33ae3169769",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4179-75af-960b-0a1f816c99cc.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with white cabinets, wood countertops, a black refrigerator, and a chandelier.",
        "public_id": "019fb44c-4179-75af-960b-0a1f816c99cc",
        "storage_key": "property/6767906449165645/019fb44c-4179-75af-960b-0a1f816c99cc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright kitchen and dining nook in a modern apartment, featuring white cabinetry, wood countertops, a round table, chandelier, and a view of the outdoors.",
      "link": "",
      "alt_text": "Kitchen and dining area with white cabinets, wood countertops, a black refrigerator, and a chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304682%20(2).JPG"
    },
    {
      "id": "custom_260de997-60b5-4269-beb2-54950d7bb9c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4486-76e2-aedb-a408f542894c.webp",
      "image_media": {
        "alt_text": "Bathroom with sink vanity, mirror, toilet, shower curtain, and wooden cabinets.",
        "public_id": "019fb44c-4486-76e2-aedb-a408f542894c",
        "storage_key": "property/6767906449165645/019fb44c-4486-76e2-aedb-a408f542894c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a granite-style counter, wooden cabinetry, a wide mirror, and decorative accents.",
      "link": "",
      "alt_text": "Bathroom with sink vanity, mirror, toilet, shower curtain, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304897%20(1).JPG"
    },
    {
      "id": "custom_5d434757-c2ea-42f5-9483-c13b6fd35c63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-44bf-705f-a8bb-9d520abc2fdf.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen with white appliances, light wood cabinets, and a geometric rug.",
        "public_id": "019fb44c-44bf-705f-a8bb-9d520abc2fdf",
        "storage_key": "property/6767906449165645/019fb44c-44bf-705f-a8bb-9d520abc2fdf.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with white appliances, light wood cabinets, and a geometric rug.",
      "link": "",
      "alt_text": "Compact apartment kitchen with white appliances, light wood cabinets, and a geometric rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304837%20(1).JPG"
    },
    {
      "id": "custom_02215ab1-7ec5-4a94-9c4f-ba882c2056dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4752-7130-9c4f-f1be6e0f4e02.webp",
      "image_media": {
        "alt_text": "Bathroom with wooden vanity, granite countertop, white sink, toilet, and shower curtain.",
        "public_id": "019fb44c-4752-7130-9c4f-f1be6e0f4e02",
        "storage_key": "property/6767906449165645/019fb44c-4752-7130-9c4f-f1be6e0f4e02.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a wooden vanity, granite-like countertop, white sink, toilet, and shower curtain.",
      "link": "",
      "alt_text": "Bathroom with wooden vanity, granite countertop, white sink, toilet, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304967%20(2).JPG"
    },
    {
      "id": "custom_ef01f6cc-2899-4e37-ace0-a9e3f0b8784d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
      "image_media": {
        "alt_text": "Apartment kitchen with white appliances, wooden cabinets, and a sink.",
        "public_id": "019fb44c-4cdc-773d-87ea-8d12fa547536",
        "storage_key": "property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen featuring white appliances, wooden cabinets, and a spacious counter area.",
      "link": "",
      "alt_text": "Apartment kitchen with white appliances, wooden cabinets, and a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304737%20(1).JPG"
    },
    {
      "id": "custom_b3598e28-3767-434b-86f6-7ac61e7cf699",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4eb7-734c-a1bf-3194e8525ff3.webp",
      "image_media": {
        "alt_text": "Interior community laundry room with a row of washing machines along the wall.",
        "public_id": "019fb44c-4eb7-734c-a1bf-3194e8525ff3",
        "storage_key": "property/6767906449165645/019fb44c-4eb7-734c-a1bf-3194e8525ff3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "On-site communal laundry room for residents, featuring a row of washing machines and a dryer in a clean, well-lit space.",
      "link": "",
      "alt_text": "Interior community laundry room with a row of washing machines along the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305102.JPG"
    },
    {
      "id": "custom_bdf9866f-44d4-46cf-a21a-88cd88c02811",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd090-3273-73e5-a893-ba9b5a94f1f4.webp",
      "image_media": {
        "alt_text": "Pet grooming station with grooming table, hair dryer, and leash hooks.",
        "public_id": "019dd090-3273-73e5-a893-ba9b5a94f1f4",
        "storage_key": "property/6767906449165645/019dd090-3273-73e5-a893-ba9b5a94f1f4.webp",
        "width": 3072,
        "height": 2038
      },
      "title": "Community",
      "description": "Grooming station equipped with a table, professional hair dryer, and convenient leash hooks for pet owners.",
      "link": "",
      "alt_text": "Pet grooming station with grooming table, hair dryer, and leash hooks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e76ea2e-3832-40b4-9779-603d3ec61b83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd090-326e-75b4-87c2-67c05e2e803d.webp",
      "image_media": {
        "alt_text": "Interior of a pet grooming spa with paw prints and a large dog paw graphic.",
        "public_id": "019dd090-326e-75b4-87c2-67c05e2e803d",
        "storage_key": "property/6767906449165645/019dd090-326e-75b4-87c2-67c05e2e803d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious pet grooming area with multiple washing stations and decorative paw prints. Perfect for pampering your furry friends.",
      "link": "",
      "alt_text": "Interior of a pet grooming spa with paw prints and a large dog paw graphic.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d938e694-5870-4f7e-b726-9ce7f704bd68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-5259-7646-b944-9ad30b192331.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with comfortable seating, fireplace, and large windows.",
        "public_id": "019fcea7-5259-7646-b944-9ad30b192331",
        "storage_key": "property/6767906449165645/019fcea7-5259-7646-b944-9ad30b192331.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring ample seating, a cozy fireplace, and a bright, airy atmosphere.",
      "link": "",
      "alt_text": "Spacious community lounge area with comfortable seating, fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f7b57aa-4f5f-48ca-a15c-f3a2aa525a84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-525e-70d8-8f89-7033e84ba84e.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with high ceilings, fireplace, seating areas, and a reception desk.",
        "public_id": "019fcea7-525e-70d8-8f89-7033e84ba84e",
        "storage_key": "property/6767906449165645/019fcea7-525e-70d8-8f89-7033e84ba84e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfort and style in our community lounge, featuring a cozy fireplace, ample seating, and a welcoming reception area. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Spacious community lounge with high ceilings, fireplace, seating areas, and a reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a8236eae-e898-44d4-b2a7-2d3d76982c6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-47e3-713e-a122-cb6f2a9b68c1.webp",
      "image_media": {
        "alt_text": "Reception desk with computer and chairs, overlooking pool and apartment buildings.",
        "public_id": "019fcea7-47e3-713e-a122-cb6f2a9b68c1",
        "storage_key": "property/6767906449165645/019fcea7-47e3-713e-a122-cb6f2a9b68c1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome desk in the leasing office, with a computer, chairs, and a view of the community pool and surrounding apartment buildings.",
      "link": "",
      "alt_text": "Reception desk with computer and chairs, overlooking pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a661c83c-e01c-4227-894e-81010572d17d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-525d-7544-8d33-7fab2c4a586d.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace, comfortable seating, and a bar area.",
        "public_id": "019fcea7-525d-7544-8d33-7fab2c4a586d",
        "storage_key": "property/6767906449165645/019fcea7-525d-7544-8d33-7fab2c4a586d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community living room. Enjoy the cozy fireplace, ample seating, and a stylish bar area perfect for socializing.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace, comfortable seating, and a bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3972a11c-b732-43d9-b173-9708e509bdd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
      "image_media": {
        "alt_text": "Dining area with round table and four chairs, near kitchen and window view.",
        "public_id": "019fcea7-2d64-75dc-9c03-23c147dcd5e4",
        "storage_key": "property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, perfect for intimate gatherings. Features a stylish round table with comfortable seating, adjacent to the kitchen and offering a pleasant view of the outdoors.",
      "link": "",
      "alt_text": "Dining area with round table and four chairs, near kitchen and window view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_06b77be3-7b8e-4078-944a-2bb5d9175535",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fed5d-152d-76fe-b6bc-7e1817fe2f3b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered patio area.",
        "public_id": "019fed5d-152d-76fe-b6bc-7e1817fe2f3b",
        "storage_key": "property/6767906449165645/019fed5d-152d-76fe-b6bc-7e1817fe2f3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool, complete with comfortable lounge chairs and a shaded patio perfect for escaping the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered patio area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1bf29e5f-9dd4-4811-850e-b47e4f2af2d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fed5c-fefb-7166-bb2d-a6177f0f2266.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fed5c-fefb-7166-bb2d-a6177f0f2266",
        "storage_key": "property/6767906449165645/019fed5c-fefb-7166-bb2d-a6177f0f2266.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d963d24-a128-4d38-b84c-a629b69dc569",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fed5d-0012-7581-897a-0eb4e271bcd7.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and a large weeping willow tree next to apartment buildings.",
        "public_id": "019fed5d-0012-7581-897a-0eb4e271bcd7",
        "storage_key": "property/6767906449165645/019fed5d-0012-7581-897a-0eb4e271bcd7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by lush greenery and comfortable lounge seating.",
      "link": "",
      "alt_text": "Sparkling swimming pool with lounge chairs and a large weeping willow tree next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2dbc5beb-6fb4-47db-887d-883b67331ee1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-c2f7-7679-9486-07884d2fda5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c2f7-7679-9486-07884d2fda5c",
        "storage_key": "property/6767906449165645/019d2709-c2f7-7679-9486-07884d2fda5c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2c1-728c-8627-ac56de877a1f",
        "storage_key": "property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a2016a8c-95f5-4539-b43b-eca3e51135b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-c258-75a8-a365-d87c9c1453af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c258-75a8-a365-d87c9c1453af",
        "storage_key": "property/6767906449165645/019d2709-c258-75a8-a365-d87c9c1453af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2c1-728c-8627-ac56de877a1f",
        "storage_key": "property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d20ae53d-d916-480c-8af5-72ca5c956d6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-c577-708e-b33c-2821cfcb3c85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c577-708e-b33c-2821cfcb3c85",
        "storage_key": "property/6767906449165645/019d2709-c577-708e-b33c-2821cfcb3c85.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2c1-728c-8627-ac56de877a1f",
        "storage_key": "property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_12a1bd55-c734-4e88-a2c0-47686f431f93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-c197-73a7-9673-d7d6ad44e992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c197-73a7-9673-d7d6ad44e992",
        "storage_key": "property/6767906449165645/019d2709-c197-73a7-9673-d7d6ad44e992.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2c1-728c-8627-ac56de877a1f",
        "storage_key": "property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3bf0093f-11c0-4a65-adad-2ba23241d8ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-c65a-7599-843d-3d3a1b61ae4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c65a-7599-843d-3d3a1b61ae4b",
        "storage_key": "property/6767906449165645/019d2709-c65a-7599-843d-3d3a1b61ae4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2c1-728c-8627-ac56de877a1f",
        "storage_key": "property/6767906449165645/019d2709-f2c1-728c-8627-ac56de877a1f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4e81364c-2d78-4629-a451-c5e8c1947d7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-c6f1-732a-b8bb-650cc468017e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c6f1-732a-b8bb-650cc468017e",
        "storage_key": "property/6767906449165645/019d2709-c6f1-732a-b8bb-650cc468017e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2f7-7001-bcc3-fbda9a723a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2f7-7001-bcc3-fbda9a723a18",
        "storage_key": "property/6767906449165645/019d2709-f2f7-7001-bcc3-fbda9a723a18.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cb04ab71-b907-46d3-9951-986a2fb0521e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-c7d7-7608-a092-13fb94e2727e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c7d7-7608-a092-13fb94e2727e",
        "storage_key": "property/6767906449165645/019d2709-c7d7-7608-a092-13fb94e2727e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2f7-7001-bcc3-fbda9a723a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2f7-7001-bcc3-fbda9a723a18",
        "storage_key": "property/6767906449165645/019d2709-f2f7-7001-bcc3-fbda9a723a18.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2edb7c98-b6f9-4930-bb52-f616f20aa0e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-caec-7550-ac9b-03f20ff289bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-caec-7550-ac9b-03f20ff289bd",
        "storage_key": "property/6767906449165645/019d2709-caec-7550-ac9b-03f20ff289bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2d7-750d-9335-5c3f1e31a0ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2d7-750d-9335-5c3f1e31a0ef",
        "storage_key": "property/6767906449165645/019d2709-f2d7-750d-9335-5c3f1e31a0ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ff380c54-24fc-4f82-8360-fb469bb526d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-cabb-724f-bfc3-3a2dabed4332.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cabb-724f-bfc3-3a2dabed4332",
        "storage_key": "property/6767906449165645/019d2709-cabb-724f-bfc3-3a2dabed4332.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2d7-750d-9335-5c3f1e31a0ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2d7-750d-9335-5c3f1e31a0ef",
        "storage_key": "property/6767906449165645/019d2709-f2d7-750d-9335-5c3f1e31a0ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_d91df69d-59c8-4de8-8246-8d360d231b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-cc96-74dd-9958-c965c1b154f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cc96-74dd-9958-c965c1b154f3",
        "storage_key": "property/6767906449165645/019d2709-cc96-74dd-9958-c965c1b154f3.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2d7-750d-9335-5c3f1e31a0ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2d7-750d-9335-5c3f1e31a0ef",
        "storage_key": "property/6767906449165645/019d2709-f2d7-750d-9335-5c3f1e31a0ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9332f9e5-f387-4405-9018-d6c959838b1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-ce18-74ac-ac5f-4c4b1130a3c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ce18-74ac-ac5f-4c4b1130a3c1",
        "storage_key": "property/6767906449165645/019d2709-ce18-74ac-ac5f-4c4b1130a3c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2fe-767d-a3c5-69e6752fcf9f",
        "storage_key": "property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_10ca56aa-59ec-40d3-821a-7ea62466cba5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d0dc-751f-9f3b-9163908991ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d0dc-751f-9f3b-9163908991ec",
        "storage_key": "property/6767906449165645/019d2709-d0dc-751f-9f3b-9163908991ec.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2fe-767d-a3c5-69e6752fcf9f",
        "storage_key": "property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_23f68bf7-546a-4b14-9534-49fc4c500375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-cf5c-76eb-a6ec-7d90443cdd0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cf5c-76eb-a6ec-7d90443cdd0c",
        "storage_key": "property/6767906449165645/019d2709-cf5c-76eb-a6ec-7d90443cdd0c.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2fe-767d-a3c5-69e6752fcf9f",
        "storage_key": "property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c9cb9672-20f4-48ad-9c7c-d9ce6b0ce99c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d0ed-728b-a488-694bfe51f059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d0ed-728b-a488-694bfe51f059",
        "storage_key": "property/6767906449165645/019d2709-d0ed-728b-a488-694bfe51f059.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2fe-767d-a3c5-69e6752fcf9f",
        "storage_key": "property/6767906449165645/019d2709-f2fe-767d-a3c5-69e6752fcf9f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_402cf14d-40c1-47c6-951e-d9a893def397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d280-733e-a88d-812d9882a4e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d280-733e-a88d-812d9882a4e1",
        "storage_key": "property/6767906449165645/019d2709-d280-733e-a88d-812d9882a4e1.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_d399220d-f9b2-4fb1-9d76-9f90997d734f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d4a3-77e5-a98a-c05549cabf16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d4a3-77e5-a98a-c05549cabf16",
        "storage_key": "property/6767906449165645/019d2709-d4a3-77e5-a98a-c05549cabf16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d6dd9c24-2b77-45b1-bba3-5e9bcdfa7fae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d6c1-75c2-b6e2-fca2bb0e3ab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d6c1-75c2-b6e2-fca2bb0e3ab5",
        "storage_key": "property/6767906449165645/019d2709-d6c1-75c2-b6e2-fca2bb0e3ab5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_e5918656-1d7d-4f11-a796-ed323177d6f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d600-7570-9407-3d54239e7887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d600-7570-9407-3d54239e7887",
        "storage_key": "property/6767906449165645/019d2709-d600-7570-9407-3d54239e7887.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_dbccf654-2daa-492c-b1c1-dee14582df36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d6a7-7048-a51b-3358cdcc99e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d6a7-7048-a51b-3358cdcc99e0",
        "storage_key": "property/6767906449165645/019d2709-d6a7-7048-a51b-3358cdcc99e0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_cffa5d37-f7ff-417b-afe0-76ea96f0fc4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-d945-7247-babe-e0848cfa8093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d945-7247-babe-e0848cfa8093",
        "storage_key": "property/6767906449165645/019d2709-d945-7247-babe-e0848cfa8093.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9cc5300e-3a40-40b5-add2-c33408f10609",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-dc20-70b3-8d8b-8222b6837dce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dc20-70b3-8d8b-8222b6837dce",
        "storage_key": "property/6767906449165645/019d2709-dc20-70b3-8d8b-8222b6837dce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_42beb64f-c9cc-45d3-8414-ab76f9c1dc13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-dae2-72f9-97db-290c5100641e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dae2-72f9-97db-290c5100641e",
        "storage_key": "property/6767906449165645/019d2709-dae2-72f9-97db-290c5100641e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_54d73836-cd41-4038-ad2e-9bfc20177710",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-db23-74c2-a237-6fff3d4affff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-db23-74c2-a237-6fff3d4affff",
        "storage_key": "property/6767906449165645/019d2709-db23-74c2-a237-6fff3d4affff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d65bcd93-434a-42f7-a288-5201b86ce2ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-ddcb-722d-8967-752689b3b425.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ddcb-722d-8967-752689b3b425",
        "storage_key": "property/6767906449165645/019d2709-ddcb-722d-8967-752689b3b425.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_38cfb418-4178-4dff-aab6-8c9c5229747a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "9142 E 31st St, Tulsa, OK 74145, USA",
      "poi_short_description": "Gym offering cardio and strength-training equipment, as well as Pilates, yoga, and cycling classes.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment, including free weights, machines, and cardio options, as well as classes and tanning booths. They highlight the clean facilities, spacious layout, and 24/7 availability, making it convenient for people with unpredictable schedules. They also like the friendly, helpful, and understanding staff, and the welcoming, non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-df4e-770f-8404-bb5ca6c132e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-df4e-770f-8404-bb5ca6c132e9",
        "storage_key": "property/6767906449165645/019d2709-df4e-770f-8404-bb5ca6c132e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/east-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362762748097342813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.1175059",
      "poi_longitude": "-95.8708861",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-438-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4own9SMtocRXS1WmAY2FOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_90b260a8-ae5c-4b90-9670-b65bcc4192bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-df2f-74bc-b419-7f270aa7b38f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-df2f-74bc-b419-7f270aa7b38f",
        "storage_key": "property/6767906449165645/019d2709-df2f-74bc-b419-7f270aa7b38f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_05ec7064-8b98-4c01-b1bd-9bb0ca5aca31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e1b2-77e9-9ed5-82d36d51a8d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e1b2-77e9-9ed5-82d36d51a8d7",
        "storage_key": "property/6767906449165645/019d2709-e1b2-77e9-9ed5-82d36d51a8d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f70c-75ae-98e4-4be5491fc64e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f70c-75ae-98e4-4be5491fc64e",
        "storage_key": "property/6767906449165645/019d2709-f70c-75ae-98e4-4be5491fc64e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6962b724-3034-4a3d-bd81-489e873ec936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e222-71bb-80a6-78e994be2d78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e222-71bb-80a6-78e994be2d78",
        "storage_key": "property/6767906449165645/019d2709-e222-71bb-80a6-78e994be2d78.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f70c-75ae-98e4-4be5491fc64e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f70c-75ae-98e4-4be5491fc64e",
        "storage_key": "property/6767906449165645/019d2709-f70c-75ae-98e4-4be5491fc64e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_be1ef618-c91b-4c33-bdfd-b358db177f87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e3d1-753a-ab3d-2352c3fcb5a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e3d1-753a-ab3d-2352c3fcb5a3",
        "storage_key": "property/6767906449165645/019d2709-e3d1-753a-ab3d-2352c3fcb5a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6c5-70b6-a40f-51ca8eeffdcd",
        "storage_key": "property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bd421df3-0a43-42fa-8f1d-7db1e7161d84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e407-7303-87c0-4fa889cf86ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e407-7303-87c0-4fa889cf86ee",
        "storage_key": "property/6767906449165645/019d2709-e407-7303-87c0-4fa889cf86ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6c5-70b6-a40f-51ca8eeffdcd",
        "storage_key": "property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1265ecc4-209b-4cc1-80ce-397cd4c55d65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e65f-76bb-9290-0678d5816fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e65f-76bb-9290-0678d5816fdc",
        "storage_key": "property/6767906449165645/019d2709-e65f-76bb-9290-0678d5816fdc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6c5-70b6-a40f-51ca8eeffdcd",
        "storage_key": "property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1b388826-3e1c-4c27-9a1b-4be2d0136369",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e825-77bc-832f-94cd9a5dc76b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e825-77bc-832f-94cd9a5dc76b",
        "storage_key": "property/6767906449165645/019d2709-e825-77bc-832f-94cd9a5dc76b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6c5-70b6-a40f-51ca8eeffdcd",
        "storage_key": "property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_85b791d4-32c0-4c41-8024-1b53bea1c228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e8dc-745c-ba3b-7e29d4169b39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e8dc-745c-ba3b-7e29d4169b39",
        "storage_key": "property/6767906449165645/019d2709-e8dc-745c-ba3b-7e29d4169b39.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6c5-70b6-a40f-51ca8eeffdcd",
        "storage_key": "property/6767906449165645/019d2709-f6c5-70b6-a40f-51ca8eeffdcd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_92acf977-c1aa-4231-bc85-03376d1abe50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Harvey Young Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1419 S 135th E Ave, Tulsa, OK 74108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-e929-7557-95a8-fb66821014c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e929-7557-95a8-fb66821014c7",
        "storage_key": "property/6767906449165645/019d2709-e929-7557-95a8-fb66821014c7.webp",
        "width": 1242,
        "height": 932
      },
      "poi_business_url": "http://harvey-young-airport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091711320843246332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-young-airport",
      "poi_latitude": "36.1412138",
      "poi_longitude": "-95.8256711",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-298-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6dc-709d-a4d3-9abeae7f09c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6dc-709d-a4d3-9abeae7f09c9",
        "storage_key": "property/6767906449165645/019d2709-f6dc-709d-a4d3-9abeae7f09c9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJffM4REPztocR_FoKDq6s7Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2fb7e937-ca94-4671-8715-d81baf408ce4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-eb71-716c-b476-c2e932356a95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-eb71-716c-b476-c2e932356a95",
        "storage_key": "property/6767906449165645/019d2709-eb71-716c-b476-c2e932356a95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7dfeec0f-8c03-4dc9-ae47-ac1d0a813aea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-ec5f-776e-8790-a8ad505682dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ec5f-776e-8790-a8ad505682dd",
        "storage_key": "property/6767906449165645/019d2709-ec5f-776e-8790-a8ad505682dd.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8a4a017f-81ff-4574-b1af-c9a4f84363a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-ee93-7069-a392-b31995eeee6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ee93-7069-a392-b31995eeee6d",
        "storage_key": "property/6767906449165645/019d2709-ee93-7069-a392-b31995eeee6d.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4b131408-e480-4485-b89b-7c6c52fa6601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9f98e799-066b-4e15-b508-1adc70c31749",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-edae-70e4-9187-253d57a21e71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-edae-70e4-9187-253d57a21e71",
        "storage_key": "property/6767906449165645/019d2709-edae-70e4-9187-253d57a21e71.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f6ad-7563-a951-4d55fcb39b65",
        "storage_key": "property/6767906449165645/019d2709-f6ad-7563-a951-4d55fcb39b65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b987a787-7ed7-4b7d-93bd-72ea4c35cd51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Community Care College",
      "poi_type": "Education",
      "poi_address": "4242 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-c825-70d8-ac05-b953b13bc80c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c825-70d8-ac05-b953b13bc80c",
        "storage_key": "property/6767906449165645/019d7913-c825-70d8-ac05-b953b13bc80c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://communitycarecollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7526492564899100518&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "community-care-college",
      "poi_latitude": "36.1014829",
      "poi_longitude": "-95.9050357",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-610-0027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvQBh-KOStocRZvdtVxx5c2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_bb46a203-cfcb-410d-ac38-a871d0265da5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-c378-7683-888b-2f2ff6b3afc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c378-7683-888b-2f2ff6b3afc8",
        "storage_key": "property/6767906449165645/019d7913-c378-7683-888b-2f2ff6b3afc8.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ed6de931-f7cb-4ad0-953c-f9cc9f4c6ec3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Holland Hall Upper School",
      "poi_type": "Education",
      "poi_address": "5666 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hollandhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7685982764765177901&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "holland-hall-upper-school",
      "poi_latitude": "36.0423675",
      "poi_longitude": "-95.9165089",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-481-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJscgbbheStocRLWiaO5oYqmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f29914de-5bbb-4527-9490-c46baaf64230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Jefferson Elementary School",
      "poi_type": "Education",
      "poi_address": "8418 S 107th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3571407557531304534&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jefferson-elementary-school",
      "poi_latitude": "36.0407212",
      "poi_longitude": "-95.8576676",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-357-4339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6ZuzTi2MtocRVoLMXkAwkDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_13feba31-fe61-4d05-9259-7104c96d4f7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Union 6th/7th Grade Center",
      "poi_type": "Education",
      "poi_address": "10100 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-c39d-7338-8237-34626dddb7ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c39d-7338-8237-34626dddb7ff",
        "storage_key": "property/6767906449165645/019d7913-c39d-7338-8237-34626dddb7ff.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357368135835625738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-6th-7th-grade-center",
      "poi_latitude": "36.0750199",
      "poi_longitude": "-95.8647424",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0q97M9mtocRCqk279gwfqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2198ed97-1fca-4ec3-913c-fe091f568e55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-c3a2-73bd-9885-5df526fb0443.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c3a2-73bd-9885-5df526fb0443",
        "storage_key": "property/6767906449165645/019d7913-c3a2-73bd-9885-5df526fb0443.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ba2ea9ff-1853-43ec-ae28-e8ec4a7f84a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-ca20-711a-8a38-0edbbadb60dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ca20-711a-8a38-0edbbadb60dc",
        "storage_key": "property/6767906449165645/019d7913-ca20-711a-8a38-0edbbadb60dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a8baa0a1-b157-4d89-beaa-77c9502dea8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Broken Arrow Beauty College",
      "poi_type": "Education",
      "poi_address": "2001 S Elm Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-cb29-770f-86aa-b8d26c501909.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-cb29-770f-86aa-b8d26c501909",
        "storage_key": "property/6767906449165645/019d7913-cb29-770f-86aa-b8d26c501909.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.babeautycollege.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11149710138384494756&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-beauty-college",
      "poi_latitude": "36.0297508",
      "poi_longitude": "-95.7970306",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-294-8627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d506667d342d",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d506667d342d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIyUg0j2CRkYRpLD6Eky6u5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_f95144c7-5886-4398-b3ed-205306fdda35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "The Blue Dome",
      "poi_type": "Restaurants",
      "poi_address": "320 E 2nd St S, Tulsa, OK 74120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-cecd-7209-8c09-88b242c7b63b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-cecd-7209-8c09-88b242c7b63b",
        "storage_key": "property/6767906449165645/019d7913-cecd-7209-8c09-88b242c7b63b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bluedomedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3891437793038114782&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-blue-dome",
      "poi_latitude": "36.1557212",
      "poi_longitude": "-95.9870152",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-938-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-c287f1a86b7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-c287f1a86b7e",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-c287f1a86b7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTh7bH_rtocR3h-RFw4qATY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_4cefd0c4-774f-48a4-843e-b1e3c31b61ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Tulsa’s Incredible Food and Fun",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Popular place for parties offering go-karts, rides, games & pizza with an all-you-can-eat buffet.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including pizza, hot dogs, tacos, and a salad bar, and has fun games and attractions like laser tag, bumper cars, and a roller coaster. They also highlight the fun, family-friendly atmosphere and the helpful, friendly staff.\n\nOther reviews mention some games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-d2de-75e8-ae8b-b6ace6b4ae48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d2de-75e8-ae8b-b6ace6b4ae48",
        "storage_key": "property/6767906449165645/019d7913-d2de-75e8-ae8b-b6ace6b4ae48.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblefoodandfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-s-incredible-food-and-fun",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d98cb5d661e0",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_6546d7a9-9590-4bc2-a552-26428d3b59f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Sake2Me Sushi",
      "poi_type": "Restaurants",
      "poi_address": "9205 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual Japanese restaurant offering all-you-can-eat sushi & sashimi, plus noodles & teriyaki dishes.",
      "poi_long_description": "People say this sushi restaurant offers delicious and fresh sushi, including a wide variety of rolls and sashimi, as well as teriyaki chicken and calamari. They highlight the generous portions, reasonable prices, and the all-you-can-eat option, which they find to be a great value. They also like the chill and relaxed atmosphere, and the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-d408-70fd-90fa-b04f52dea924.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d408-70fd-90fa-b04f52dea924",
        "storage_key": "property/6767906449165645/019d7913-d408-70fd-90fa-b04f52dea924.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sake2mesushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793506518580779662&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sake2me-sushi",
      "poi_latitude": "36.061592",
      "poi_longitude": "-95.873192",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-249-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d98cb5d661e0",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeCG1folTIYRjtp6WUqG6Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_7d6ca3bc-dfa5-4004-b05f-23f9a273862c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Bricktown Brewery",
      "poi_type": "Restaurants",
      "poi_address": "9409 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual pizza joint specializing in local brews and serving burgers and seafood platters.",
      "poi_long_description": "Diners say this restaurant serves up delicious chicken fried chicken, chicken fried steak, and breakfast burgers, and they praise the Kolsch beer. They also highlight the friendly and attentive service, and the welcoming atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-d80e-74b2-b604-d5345b39de24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d80e-74b2-b604-d5345b39de24",
        "storage_key": "property/6767906449165645/019d7913-d80e-74b2-b604-d5345b39de24.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bricktownbrewery.com/location/woodland-hills/?utm_source=gbp&utm_medium=cpc&utm_campaign=bricktown_brewery",
      "poi_directions_map_url": "https://maps.google.com/?cid=4102797412021264681&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-brewery",
      "poi_latitude": "36.0614101",
      "poi_longitude": "-95.8716959",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-994-4456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d98cb5d661e0",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bN2wL2NtocRKWHrOIIQ8Dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_56ba5aca-afb2-471d-aa6b-dc94d7935f34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Uncle Julio's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10333 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, homemade tortillas, and margaritas. They also highlight the attentive service and fun, festive atmosphere.\n\nOther reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-dc3a-72f9-9e6c-91770134e4e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dc3a-72f9-9e6c-91770134e4e6",
        "storage_key": "property/6767906449165645/019d7913-dc3a-72f9-9e6c-91770134e4e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8326019147073341189&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-mexican-restaurant",
      "poi_latitude": "36.0622881",
      "poi_longitude": "-95.8608222",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-999-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d98cb5d661e0",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TjRyvSNtocRBUdoFk32i3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_29a6fec1-44c9-48f9-9252-986a63d191c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Nola's ...Creole & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "1334 E 15th St, Tulsa, OK 74120, USA",
      "poi_short_description": "Relaxed Cajun and Creole place with a chandelier-lit bar, old-timey photos, and Prohibition era cocktails.",
      "poi_long_description": "People say this Cajun restaurant serves delicious dishes like Voodoo Chicken, shrimp and grits, and boudin balls. They highlight the generous portions, reasonable prices, and fun, speakeasy-like atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-d85d-77ab-93f8-3c8603ac74a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d85d-77ab-93f8-3c8603ac74a8",
        "storage_key": "property/6767906449165645/019d7913-d85d-77ab-93f8-3c8603ac74a8.webp",
        "width": 1280,
        "height": 1218
      },
      "poi_business_url": "http://www.nolastulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=489749569356745618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nola-s-creole-cocktails",
      "poi_latitude": "36.1400087",
      "poi_longitude": "-95.9748442",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-779-7766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d98cb5d661e0",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21HLopnstocRkstodqPwywY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_9de27de7-7ca0-4c04-8ded-59626f066d7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Sisserou's Caribbean Restaurant & Catering",
      "poi_type": "Restaurants",
      "poi_address": "107 N Boulder Ave C, Tulsa, OK 74103, USA",
      "poi_short_description": "Jerk chicken, stewed oxtail & mojitos served in a stylish, contemporary setting with valet parking.",
      "poi_long_description": "People say this Caribbean restaurant serves delicious oxtail stew, jerk chicken, and beef patties. They highlight the generous portions, fresh ingredients, and flavorful dishes. They also like the attentive service and pleasant atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-da33-7276-b441-e569059f50e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-da33-7276-b441-e569059f50e5",
        "storage_key": "property/6767906449165645/019d7913-da33-7276-b441-e569059f50e5.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.sisserousrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7131052098303193055&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sisserou-s-caribbean-restaurant-catering",
      "poi_latitude": "36.1575133",
      "poi_longitude": "-95.994075",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-576-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a76e-72da-bc1f-d98cb5d661e0",
        "storage_key": "property/6767906449165645/019cfb4d-a76e-72da-bc1f-d98cb5d661e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfW6TZ3rtocR328q-hmW9mI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "custom_74148018-967a-4fc3-aa54-eb83bb72fc5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Kilkenny's Irish Pub",
      "poi_type": "Restaurants",
      "poi_address": "1413 E 15th St, Tulsa, OK 74120, USA",
      "poi_short_description": "Pub fare from sandwiches to fish dinners plus drinks & brunch in a traditional dark-wood setting.",
      "poi_long_description": "People say this Irish pub serves delicious fish and chips, scotch eggs, and bangers and mash. They highlight the generous portions, reasonable prices, and authentic Irish atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-e31b-71e0-87ee-94f53ecdc6ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e31b-71e0-87ee-94f53ecdc6ec",
        "storage_key": "property/6767906449165645/019d7913-e31b-71e0-87ee-94f53ecdc6ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsairishpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5796738057828299928&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kilkenny-s-irish-pub",
      "poi_latitude": "36.1407071",
      "poi_longitude": "-95.9728385",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-582-8282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7914-05f0-72b9-b4f3-07cab35f6391.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7914-05f0-72b9-b4f3-07cab35f6391",
        "storage_key": "property/6767906449165645/019d7914-05f0-72b9-b4f3-07cab35f6391.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5af5ZnstocRmPTXGI0mclA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "custom_25627c5e-6e16-4ac4-8a4e-e7b05eeb80a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "The Farm Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "5321 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "Shopping mall with a variety of shops, including an art gallery, Italian restaurant, and bank.",
      "poi_long_description": "People say this shopping center offers a variety of shops and a unique concept. They also highlight the convenient location, ample parking, and friendly service.\n\nOther reviews mention some stores can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-e461-7022-baa8-f45cfa6005c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e461-7022-baa8-f45cfa6005c7",
        "storage_key": "property/6767906449165645/019d7913-e461-7022-baa8-f45cfa6005c7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.thefarmshoppingtulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=342653135508264204&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-farm-shopping-center",
      "poi_latitude": "36.0896801",
      "poi_longitude": "-95.9041603",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa2_Zh5yStocRDNUkFzZZwQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8f8db9ab-1d97-4361-8f04-a51ea1fc2a9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Mid-range chain stores & specialty shops, plus familiar fast food, in a refined strip-mall format.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and restaurants. They highlight the convenient location, easy parking, and clean environment. They also like the easy access and the variety of shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-e5f7-733d-a424-0b90633440eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e5f7-733d-a424-0b90633440eb",
        "storage_key": "property/6767906449165645/019d7913-e5f7-733d-a424-0b90633440eb.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cc580f59-7675-4d02-9ec7-f6f83860e321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6625 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer stocking toys, clothing, electronics, home goods, furniture, groceries and more.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, clothing, and household items. They also highlight the convenient one-stop shopping experience and the affordable prices.\n\nOther reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-e6d1-734c-8da4-353b2b716ca2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e6d1-734c-8da4-353b2b716ca2",
        "storage_key": "property/6767906449165645/019d7913-e6d1-734c-8da4-353b2b716ca2.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/894-tulsa-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18164824787754373520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.0674096",
      "poi_longitude": "-95.8830124",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-294-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjfQHJZqNtocRkFFPMedrFvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_553d7557-33f2-4b6c-b948-f07a175e5ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, great sales, and good prices. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-eba2-772e-9ec7-58fb58fce9ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-eba2-772e-9ec7-58fb58fce9ac",
        "storage_key": "property/6767906449165645/019d7913-eba2-772e-9ec7-58fb58fce9ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-425.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10465943342793208862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0629677",
      "poi_longitude": "-95.8533535",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-461-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwxxHW0yMtocRHrSN8gSAPpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_74170fbd-d24f-4bd5-834b-2778fee2f0c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Utica Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1709 Utica Square, Tulsa, OK 74114, USA",
      "poi_short_description": "Tree-lined outdoor shopping center open since 1952, featuring upscale chain brands & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including popular retail brands, specialty shops, and a Saks Fifth Avenue, as well as numerous dining options. They highlight the beautiful, open-air layout, the convenient parking, and the relaxed and inviting atmosphere. They also like the well-maintained landscaping and seasonal decorations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-ed26-723d-a85a-9598f5ce2a13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ed26-723d-a85a-9598f5ce2a13",
        "storage_key": "property/6767906449165645/019d7913-ed26-723d-a85a-9598f5ce2a13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uticasquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1952460493464208074&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "utica-square",
      "poi_latitude": "36.1321689",
      "poi_longitude": "-95.9628953",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-588-5209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAVNNJr_stocRygLrZnmIGBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_02698cc3-ee2e-4846-8456-d5d7c97c69fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Riverwalk Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 Riverwalk Terrace, Jenks, OK 74037, USA",
      "poi_short_description": "Lifestyle center on the Arkansas River and Muscogee (Creek) Nation reservation, with shopping, dining, live music, and a trail system.",
      "poi_long_description": "People say this shopping center offers a great selection of food and snacks, with many mentioning the Mexican grill. They also highlight the fun and peaceful atmosphere, beautiful scenery, and great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-edd3-770f-950d-6dd48237fa20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-edd3-770f-950d-6dd48237fa20",
        "storage_key": "property/6767906449165645/019d7913-edd3-770f-950d-6dd48237fa20.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.jenksriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11784666382402635584&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwalk-crossing",
      "poi_latitude": "36.0256838",
      "poi_longitude": "-95.95905820000002",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-518-6675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu9Z8JGCRtocRQMeYD6OLi6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1772ecb1-7564-472f-bcab-74dbcfc3d5f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Union Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "9717-10021 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Shopping center featuring an Asian market, sporting goods store, and other shops.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-f38f-76ea-b0e5-bae9fd2222c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f38f-76ea-b0e5-bae9fd2222c1",
        "storage_key": "property/6767906449165645/019d7913-f38f-76ea-b0e5-bae9fd2222c1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13820467133639834551&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-plaza",
      "poi_latitude": "36.0626762",
      "poi_longitude": "-95.8667633",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI8zbgLCNtocRtzuQUqIpzL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fd7e9106-0996-476e-83a5-db759680305a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "10127 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Open-air shopping mall with a variety of stores and restaurants, as well as a grocery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-f4d8-72b4-ae05-a0b1fdcae4b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f4d8-72b4-ae05-a0b1fdcae4b8",
        "storage_key": "property/6767906449165645/019d7913-f4d8-72b4-ae05-a0b1fdcae4b8.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7117345951080470010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marketplace",
      "poi_latitude": "36.0640208",
      "poi_longitude": "-95.8638658",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEfA9ebGNtocR-lW35W7kxWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_95865055-1346-4657-954e-b63b495a2f93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Woodland Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "8620 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Shopping mall featuring books, coffee, and games, as well as places to eat.",
      "poi_long_description": "People say this shopping center offers a great selection of stores and a wide variety of books. They highlight the convenient parking, quiet atmosphere, and peaceful vibe. They also like the helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-f93d-77fe-a1d4-b649650a59db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f93d-77fe-a1d4-b649650a59db",
        "storage_key": "property/6767906449165645/019d7913-f93d-77fe-a1d4-b649650a59db.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3263024643163273007&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woodland-plaza",
      "poi_latitude": "36.0600223",
      "poi_longitude": "-95.8790826",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIWdVcpaNtocRL7cX7Z-XSC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2e8af7e3-c27a-423b-9c63-7b6352da1ccf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Union Square Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Shopping center featuring various stores including Taco Bell.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7913-fb19-777c-aed7-104e27407ded.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-fb19-777c-aed7-104e27407ded",
        "storage_key": "property/6767906449165645/019d7913-fb19-777c-aed7-104e27407ded.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3265415215446277994&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-square-shopping-center",
      "poi_latitude": "36.0747561",
      "poi_longitude": "-95.867535",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-488-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRx9T3aeNtocRar_UaNYVUS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_63fd2090-d387-4d01-8295-0c5f45575ebe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "The Mill Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "The Mill Shopping Center, E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019d7914-0080-75dc-88c4-4ad43313bcf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7914-0080-75dc-88c4-4ad43313bcf3",
        "storage_key": "property/6767906449165645/019d7914-0080-75dc-88c4-4ad43313bcf3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11409814669655452323&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-mill-shopping-center",
      "poi_latitude": "36.0610446",
      "poi_longitude": "-95.8991533",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a784-7015-9c1d-bfdf5796d5a3",
        "storage_key": "property/6767906449165645/019cfb4d-a784-7015-9c1d-bfdf5796d5a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0aE-03eStocRo6ragf3NV54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ec6f9513-1d03-487d-b9ce-04ac240a7e6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "poi_name": "Union 9th Grade Center",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "union-9th-grade-center",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_25d09a54899642fab682f2af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_79e7de70903e1d67bb5c1b12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e8e0d16271b553e1385230d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1703f2b19a134adb6bf2aeab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_64ea2a88f70823ba6d720f9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_352f758c5c9aec5b81a4038a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0478e255-ab59-4ae0-8b0e-972a3580be22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "rating": "5.0",
      "name": "Edwin Jarboe",
      "text": "My experience at windsail was so great. I saw and noticed that you all where very respectful, honest and intelligent in responding to your tenants and i will be glad and happy living at windsail apartment.",
      "date": "2025-08-29",
      "title": ""
    },
    {
      "id": "custom_4d837475-bcec-484e-90d4-a15a9ce3427f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "rating": "5.0",
      "name": "Stacy Cullum",
      "text": "They left a bit of a mess on my bed(my bed wasn’t made) but the paint and chipping was on my bed. It’s not major but a little frustrating. This is all wet.  I’m worried there is a leak upstairs",
      "date": "2025-10-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_47751b37-8f8b-44e1-b5d2-6391b9e4e6b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4e-1dd3-7757-a741-1c196c98f492.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of swimming pool and community building exterior",
        "public_id": "019cfb4e-1dd3-7757-a741-1c196c98f492",
        "storage_key": "property/6767906449165645/019cfb4e-1dd3-7757-a741-1c196c98f492.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Windsail Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f6d644bee5aba0c3b8befed"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-5bda-73b1-b803-fb97bf028e58",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "windsail-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645"
    },
    {
      "lead_collector_id": "019cf79e-5c4a-7310-be19-d580a53b6d04",
      "lead_source": "LANDING_PAGE",
      "name": "windsail-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "page_item_url": "apartments-with-pool-in-tulsa-windsail",
      "search_query": "apartments with pool in Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Tulsa",
      "h2_subtitle": "Dive into comfort at Windsail Apts. Enjoy a refreshing pool and top-notch amenities right here in Tulsa.",
      "page_copy": "Discover unbeatable living at Windsail Apts., an outstanding choice for anyone seeking apartments with a pool in Tulsa. Nestled in the charming South Tulsa area, our community offers exquisite amenities, including a sparkling pool perfect for unwinding after a long day. Whether you're lounging by the water or taking a soothing swim, you'll find relaxation comes easy.\n\nOur lifestyle-focused amenities extend beyond the pool, providing residents with a comprehensive fitness center, tennis courts, and a cozy clubhouse ideal for social gatherings. Choose from thoughtfully designed one and two-bedroom floor plans, each featuring modern conveniences such as walk-in closets and in-home laundry. At Windsail Apts., elevate your living experience with amenities that cater to your every need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and TV stand with a television.",
        "public_id": "019fb44b-b34c-72ee-9c23-23caa8c984dc",
        "storage_key": "property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Tulsa | Windsail Apts.",
      "seo_description": "Discover Windsail Apts. in Tulsa, featuring a fabulous pool and top amenities. Find your comfortable home with us!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-south-tulsa-windsail",
      "search_query": "fitness center apartments South Tulsa",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in South Tulsa",
      "h2_subtitle": "Experience premium living at Windsail Apts. with a state-of-the-art fitness center. Find your ideal home in South Tulsa today.",
      "page_copy": "Windsail Apts. set the standard for fitness center apartments in South Tulsa. Located in one of Tulsa's most welcoming neighborhoods, this community offers a state-of-the-art fitness center designed for residents keen on maintaining an active lifestyle. Whether you're into weight training or cardio workouts, you'll find everything you need just steps from your door.\n\nBut the fitness center is only the beginning. Windsail Apts. also includes a variety of leisure amenities such as a refreshing pool and tennis courts, perfect for enhancing your wellness journey. Choose from spacious one and two-bedroom floor plans that blend comfort with style, each offering expansive walk-in closets and in-home laundry options. Experience convenience and connectivity at Windsail Apts., where modern living meets active lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and TV stand with a television.",
        "public_id": "019fb44b-b34c-72ee-9c23-23caa8c984dc",
        "storage_key": "property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments South Tulsa | Windsail Apts.",
      "seo_description": "Explore Windsail Apts. in South Tulsa. Enjoy a state-of-the-art fitness center and superb amenities at your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "page_item_url": "walk-in-closet-apartments-oklahoma-windsail",
      "search_query": "walk-in closet apartments Oklahoma",
      "category": "Amenity",
      "h1_title": "Walk-In Closet Apartments in Oklahoma",
      "h2_subtitle": "Discover spacious living at Windsail Apts. in Oklahoma. Enjoy luxurious walk-in closets and more in each apartment.",
      "page_copy": "At Windsail Apts. in Tulsa, Oklahoma, your search for walk-in closet apartments ends with unparalleled style and storage solutions. Our community offers thoughtfully designed one and two-bedroom floor plans, each featuring expansive walk-in closets that provide the perfect solution for all your storage needs. Step into a home where your wardrobe and belongings have ample space.\n\nLocated in the vibrant South Tulsa neighborhood, Windsail Apts. doesn't just stop at impressive interiors. Residents enjoy access to a suite of amenities, including a refreshing pool, a modern fitness center, and more, all designed to enhance your lifestyle. Choose Windsail for a perfect blend of comfort, convenience, and community in Oklahoma.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and TV stand with a television.",
        "public_id": "019fb44b-b34c-72ee-9c23-23caa8c984dc",
        "storage_key": "property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closet Apartments Oklahoma | Windsail Apts.",
      "seo_description": "Find exceptional walk-in closet apartments at Windsail Apts. in Oklahoma. Spacious living with top amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-74133-windsail",
      "search_query": "in-unit laundry apartments 74133",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in 74133",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Windsail Apts., located in the heart of Tulsa's 74133 area.",
      "page_copy": "Welcome to Windsail Apts., where convenience meets comfort with our in-unit laundry apartments in the 74133 area of Tulsa. Imagine the ease and efficiency of having a washer and dryer just steps away in your own residence, making laundry day hassle-free and saving you valuable time.\n\nNestled in the scenic South Tulsa neighborhood, Windsail Apts. offers more than just in-home convenience. Our residents enjoy a fantastic array of amenities, like a refreshing swimming pool and a contemporary fitness center, perfectly complementing our spacious one and two-bedroom layouts. Experience a lifestyle of ease and functionality at Windsail Apts., the perfect home for those seeking modern amenities in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and TV stand with a television.",
        "public_id": "019fb44b-b34c-72ee-9c23-23caa8c984dc",
        "storage_key": "property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments 74133 | Windsail Apts.",
      "seo_description": "Discover in-unit laundry apartments at Windsail Apts. in Tulsa's 74133 area. Enjoy modern living with superb amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-tulsa-windsail",
      "search_query": "dishwasher-equipped apartments Tulsa",
      "category": "Amenity",
      "h1_title": "Dishwasher-Equipped Apartments in Tulsa",
      "h2_subtitle": "Find modern convenience at Windsail Apts. with dishwasher-equipped apartments in Tulsa.",
      "page_copy": "Experience the charm of Windsail Apts. in Tulsa, where our dishwasher-equipped apartments provide the perfect blend of convenience and style. Enjoy state-of-the-art amenities as every unit is designed with modern living in mind, ensuring you can focus on the things you love most.\n\nLocated in South Tulsa, Windsail Apts. offers more than just functional kitchens. Our community features a refreshing swimming pool, a well-equipped fitness center, and expansive walk-in closets. Whether you're embarking on a new journey or seeking a fresh start, Windsail Apts. ensures you have everything you need to thrive in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and TV stand with a television.",
        "public_id": "019fb44b-b34c-72ee-9c23-23caa8c984dc",
        "storage_key": "property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher-Equipped Apartments Tulsa | Windsail Apts.",
      "seo_description": "Discover dishwasher-equipped apartments at Windsail Apts. in Tulsa. Enjoy modern amenities and a comfortable lifestyle in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-south-tulsa-windsail",
      "search_query": "one bedroom apartments in South Tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Explore comfortable living with our one-bedroom apartments in South Tulsa at Windsail Apts.",
      "page_copy": "Discover the perfect blend of comfort and convenience with our one bedroom apartments in South Tulsa at Windsail Apts. Designed with your lifestyle in mind, our floor plans offer spacious layouts with amenities like walk-in closets, making it an ideal choice for solo living or a cozy couple's retreat.\n\nNestled in the vibrant South Tulsa community, Windsail Apts. provides an array of community features including a sparkling pool and a modern fitness center. With additional conveniences like in-unit washers and dryers, you'll find everything you need to create a peaceful and enjoyable home at our South Tulsa location. Choose Windsail, where style meets functionality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and TV stand with a television.",
        "public_id": "019fb44b-b34c-72ee-9c23-23caa8c984dc",
        "storage_key": "property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments South Tulsa | Windsail Apts.",
      "seo_description": "Find stylish one bedroom apartments in South Tulsa at Windsail Apts. Enjoy modern living with top amenities tailored to your lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165645",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-74133-windsail",
      "search_query": "two bedroom apartments near 74133",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 74133",
      "h2_subtitle": "Discover spacious two-bedroom apartments near 74133 at Windsail Apts., perfect for comfort and convenience.",
      "page_copy": "Welcome to Windsail Apts., where our two-bedroom apartments near 74133 offer the ideal setting for comfort and convenience. Each apartment provides ample space with walk-in closets, making it perfect for families or roommates looking to share a stylish living environment.\n\nSituated in the bustling South Tulsa area, Windsail Apts. promises an array of perks, including a sparkling swimming pool and modern fitness center. With added amenities like pantry access and in-unit laundry, you'll have everything necessary for a seamless, enjoyable lifestyle. Embrace the exceptional living experience offered at Windsail Apts., where you'll find more than just a home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and TV stand with a television.",
        "public_id": "019fb44b-b34c-72ee-9c23-23caa8c984dc",
        "storage_key": "property/6767906449165645/019fb44b-b34c-72ee-9c23-23caa8c984dc.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 74133 | Windsail Apts.",
      "seo_description": "Find spacious two-bedroom apartments near 74133 at Windsail Apts. Enjoy modern amenities and comfortable living in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5234"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-7BB8BM4H3V"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151787"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/windsail-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TKJ44Z3V"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165645/019d1bdb-0783-74ce-a6b9-86db2672702b.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-736-2716"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651db7366c39d582af7ecf"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InhUUVB2M3RzU01pZXYxbXZTbEF3a1E9PSIsInZhbHVlIjoiQkRnWVZ3bGVNSTNKK2pCWEltRXdGZz09IiwibWFjIjoiNDQ4YmIyNWRkNDlmZjA3MjBjOTJhMTA1MzEwYjQ5YTM5ZDMzZDRhYTcyNDk4ODIxODA5ODRiMjMzNDkyZjY0MiJ9"
    }
  ],
  "custom_qb_id": "5234",
  "custom_ga4_id": "G-7BB8BM4H3V",
  "custom_repli_id": "10041151787",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/windsail-apartments/register/",
  "custom_google_gtm_id": "GTM-TKJ44Z3V",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165645/019d1bdb-0783-74ce-a6b9-86db2672702b.pdf",
  "custom_ppc_tracking_phone_number": "844-736-2716",
  "custom_residentboost_apartment_id": "64651db7366c39d582af7ecf",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InhUUVB2M3RzU01pZXYxbXZTbEF3a1E9PSIsInZhbHVlIjoiQkRnWVZ3bGVNSTNKK2pCWEltRXdGZz09IiwibWFjIjoiNDQ4YmIyNWRkNDlmZjA3MjBjOTJhMTA1MzEwYjQ5YTM5ZDMzZDRhYTcyNDk4ODIxODA5ODRiMjMzNDkyZjY0MiJ9"
};

export const generatedAt = '2026-08-27T21:34:36.630Z';
